export const HINT_TEXT = `Заработанные тобой баллы за день умножаются на его значение.
Если ты не пропускаешь вопросы, то ежедневно он увеличивается на 1 пункт.
Максимальное значение множителя - 5 пунктов. Напомним, что каждый день ты можешь
ответить только на один вопрос. Если ты пропустишь один день, то значение множителя
уменьшится на 1 пункт, вплоть до единицы - тебе нужно будет заново его набирать 😊`;
